const paymentOrderTypes = [
	{value: 'created_at', label: 'Yeniden Eskiye'},
	{value: 'created_at asc', label: 'Eskiden Yeniye'},
]

export default paymentOrderTypes;